import { render } from "./Receive.vue?vue&type=template&id=01f02152&scoped=true"
import script from "./Receive.vue?vue&type=script&lang=js"
export * from "./Receive.vue?vue&type=script&lang=js"

import "@/assets/css/dne-pay.css?vue&type=style&index=0&id=01f02152&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f02152"]])

export default __exports__